import { Building } from '../../@types/model/user';

export interface BuildingTagProps {
  building: Building | undefined;
}

const BuildingTag = (props: BuildingTagProps) => {
  const style = {
    background: '#e8e8e8',
    padding: '3px 10px',
    borderRadius: '10px',
    marginLeft: '10px'
  };
  if (props.building) return <span style={style}>{props.building.attributes.name}</span>;
  else return null;
};

export default BuildingTag;
